import {Checkbox, TableCell, TableHead, TableRow, TableSortLabel} from "@material-ui/core";
import React from "react";

export default function EnhancedTableHead(props) {
	const {
		onSelectAllClick,
		order,
		orderBy,
		numSelected,
		rowCount,
		onRequestSort,
		headRows,
		disableCheckbox
	} = props;
	const createSortHandler = property => event => {
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow>
				{!disableCheckbox && <TableCell padding="checkbox">
					<Checkbox
						indeterminate={numSelected > 0 && numSelected < rowCount}
						checked={numSelected === rowCount}
						onChange={onSelectAllClick}
						inputProps={{"aria-label": "Select all desserts"}}
					/>
				</TableCell>}
				{headRows.map(row => (
					<TableCell
						key={row.id}
						align={row.align ? row.align : "right"}
						padding={disableCheckbox ? 'default' : row.disablePadding ? "none" : "default"}
						sortDirection={orderBy === row.id ? order : false}
					>
						<TableSortLabel
							active={orderBy === row.id}
							direction={order}
							onClick={createSortHandler(row.id)}
						>
							{row.label}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}
